<template>
  <div class="rounded shadow-xs">
    <div class="rounded bg-white shadow-lg overflow-hidden">
      <div class="p-4 lg:p-6 bg-gray-100">
        <h3 class="text-lg">Project Cover</h3>
        <p class="text-sm text-gray-600">Change your project's cover image</p>
      </div>
      <div class="p-4 lg:p-6 space-y-4 lg:space-y-6">
        <div class="relative max-w-lg bg-gray-200 rounded overflow-hidden">
          <FilePond
            name="file"
            ref="pond"
            :label-idle="labelIdle"
            image-crop-aspect-ratio="16:9"
            image-resize-target-width="512"
            style-panel-layout="compact integrated"
            style-panel-aspect-ratio="16:9"
            style-load-indicator-position="center bottom"
            style-progress-indicator-position="right bottom"
            style-button-remove-item-position="left bottom"
            style-button-process-item-position="right bottom"
            :allow-revert="false"
            accept="image/png, image/jpeg, image/gif"
            :server="serverOptions"
            :onprocessfile="onProcessFile"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import { getCookie } from '@/utils/helpers';

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginFilePoster
);

export default {
  name: 'CoverForm',

  components: {
    FilePond,
  },

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      serverOptions: {
        process: {
          url: `/api/v1/projects/${this.project.uuid}/cover`,
          method: 'POST',
          withCredentials: true,
          timeout: 7000,
          onerror: null,
          ondata: (formData) => this.normalizeProcessData(formData),
          headers: {
            Accept: 'application/json',
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
          onload: (response) => {
            const { data = null } = JSON.parse(response);
            this.onUploaded(data);
          },
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },

  computed: {
    labelIdle() {
      if (this.project.cover) {
        return `<img src='${this.project.cover}' class='absolute inset-0 w-full h-full object-cover'>`;
      }

      return 'Drag & Drop your picture or <span class="filepond--label-action">Browse</span>';
    },
  },

  methods: {
    normalizeProcessData(formData) {
      const fileParts = formData.getAll('file').filter((value) => value instanceof Blob);

      if (fileParts.length === 0) {
        return formData;
      }

      formData.delete('file');

      fileParts.forEach((file) => {
        formData.append('file', file, file.name || 'file');
      });

      return formData;
    },

    async onUploaded(data) {
      if (!data) {
        return;
      }

      await this.$store.dispatch('entities/persistEntities', { type: 'projects', data });
    },
    onProcessFile(error, file) {
      setTimeout(() => {
        if (file.status === 5) {
          this.$refs.pond.removeFile(file.id);
        }
      }, 1500);
    },
  },
};
</script>
